import RouterLink from "../Link/RouterLink";
import "./Footer.css";
import { footer_linkedin_icon, footer_logo } from "../../Imgs/images";

function Footer() {
  return (
    <footer className="main-footer">
      <picture className="footer-logo">
        <source srcSet={footer_logo} />
        <img src={footer_logo} alt="spenseignement-logo" />
      </picture>
      <div className="footer-links">
        <RouterLink to="/entreprise" className="footer-link">
          Qui sommes-nous
        </RouterLink>
        <RouterLink to="/formation" className="footer-link">
          Formations
        </RouterLink>
        {/* <RouterLink to="/supervision" className="footer-link">
          Supervision
        </RouterLink>
        <RouterLink to="/service-entreprises" className="footer-link">
          Service aux entreprise
        </RouterLink>
        <RouterLink to="/actualites" className="footer-link">
          Actualité
        </RouterLink> */}
        <RouterLink to="/contact" className="footer-link">
          Nous contacter
        </RouterLink>
        {/* <RouterLink to="/" className="footer-link">
          Mentions Légales
        </RouterLink>
        <RouterLink to="/" className="footer-link">
          Politique de confidentialité
        </RouterLink> */}
      </div>
      <a
        href="https://www.linkedin.com/company/soudry-prevention-et-equipements/posts/?feedView=all"
        target="_blank"
        rel="noreferrer"
        className="footer-linkedin"
      >
        <picture className="footer-linkedin-icon">
          <source srcSet={footer_linkedin_icon} />
          <img src={footer_linkedin_icon} alt="spenseignement linkedin" />
        </picture>
      </a>
    </footer>
  );
}

export default Footer;
